/* eslint-disable */
import React, { Component } from 'react';
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';

import Layout from '../layout';

import styles from '../styles/pages/shipping-policy.scss';

import SignupPromotion from '../shared/signup-promotion';

const deliveryRatesByLocation = [
    [{ location: 'Pinar del Río', price: '$n/a' }, { location: 'Camagüey', price: '$n/a' }],
    [{ location: 'Artemisa', price: '$n/a' }, { location: 'Ciego de Ávila', price: '$n/a' }],
    [{ location: 'La Habana', price: '$8.00' }, { location: 'Las Tunas', price: '$n/a' }],
    [{ location: 'Mayabeque', price: '$n/a' }, { location: 'Holguín', price: '$n/a' }],
    [{ location: 'Matanzas', price: '$n/a' }, { location: 'Granma', price: '$n/a' }],
    [{ location: 'Cienfuegos', price: '$n/a' }, { location: 'Santiago de Cuba', price: '$n/a' }],
    [{ location: 'Villa Clara', price: '$n/a' }, { location: 'Guantánamo', price: '$n/a' }],
    [{ location: 'Sancti Spíritus', price: '$n/a' }],
];

const UP_TO_7_DAYS = (
    <span style={{ textTransform: 'uppercase' }}>
        <FormattedMessage
            id="shippingPolicy.subtitle3.table.text2.7"
            defaultMessage="up to 7 business days"
        />
        {' '}
        (*)
    </span>
);
const NOT_AVAILABLE = (
    <span>
        <FormattedMessage
            id="attention-not-available"
            defaultMessage="ATTENTION. NOT AVAILABLE"
        />
    </span>
);
const deliveryTimeByDestination = [
    {
        destination: 'LA HABANA',
        content: UP_TO_7_DAYS,
    }, {
        destination: 'ARTEMISA',
        content: NOT_AVAILABLE,
    }, {
        destination: 'MAYABEQUE',
        content: NOT_AVAILABLE,
    }, {
        destination: 'PINAR DEL RIO',
        content: NOT_AVAILABLE,
    }, {
        destination: 'MATANZAS',
        content: NOT_AVAILABLE,
    }, {
        destination: 'VILLA CLARA',
        content: NOT_AVAILABLE,
    }, {
        destination: 'CIEGO DE ÁVILA',
        content: NOT_AVAILABLE,
    },{
        destination: 'CIENFUEGOS',
        content: NOT_AVAILABLE,
    }, {
        destination: 'LAS TUNAS',
        content: NOT_AVAILABLE,
    }, {
        destination: 'HOLGUÍN',
        content: NOT_AVAILABLE,
    }, {
        destination: 'CAMAGÜEY',
        content: NOT_AVAILABLE,
    }, {
        destination: 'SANCTI SPIRITUS',
        content: NOT_AVAILABLE,
    }, {
        destination: 'GRANMA',
        content: NOT_AVAILABLE,
    }, {
        destination: 'SANTIAGO DE CUBA',
        content: NOT_AVAILABLE,
    }, {
        destination: 'GUANTÁNAMO',
        content: NOT_AVAILABLE,
    }
];

class ShippingPolicy extends Component {
    constructor(props) {
        super(props);

        document.title = this.props.intl.formatMessage({ id: 'shippingPolicy.title', defaultMessage: 'DELIVERY POLICY AND RATES' });
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'shippingPolicy.title', defaultMessage: 'DELIVERY POLICY AND RATES' });
        }
    }

    render() {
        const Paragraph = (props) => (
            <div className="text-justify" style={{ paddingBottom: 10, ...props.style }}>
                {props.children}
            </div>
        );

        return (
            <Layout notShowMarginBottom>
                <div className="container">
                    <div className="row">
                        <h4 className={styles.mainText}>
                            <FormattedMessage id="shippingPolicy.title" defaultMessage="DELIVERY POLICY AND RATES" />
                        </h4>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className={styles.privacyBackround}>
                                <Paragraph>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage id="shippingPolicy.subtitle1" defaultMessage="Important information about shipments" />
                                    </strong>
                                </Paragraph>
                                <FormattedHTMLMessage id="shipping-policy__important-info-about-delivery" />
                                <Paragraph>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage id="shippingPolicy.subtitle2" defaultMessage="Delivery conditions:" />
                                    </strong>
                                </Paragraph>
                                <FormattedHTMLMessage id="shipping-policy__delivery-conditions" />
                                <Paragraph>
                                    <strong>
                                        <FormattedHTMLMessage id="shippingPolicy.subtitle2.subtitle1" defaultMessage="Shipping and handling fees" />
                                    </strong>
                                    <Paragraph style={{paddingBottom: 0, paddingTop: 10 }}>
                                        <FormattedMessage
                                            id="shippingPolicy.subtitle.ArtMay"
                                            defaultMessage="Shipment to Havana, Artemisa, Mayabeque, Pinar del Rio, Matanzas, Ciego de Ávila, Las Tunas, Holguín and Santiago de Cuba"
                                        />
                                    </Paragraph>
                                </Paragraph>
                                <Paragraph>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage id="shippingPolicy.subtitle4" defaultMessage="Delivery rates by destinations:" />
                                    </strong>
                                </Paragraph>
                                <div className={styles.tableResponsive}>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th scope="col">
                                                    <FormattedMessage id="location" defaultMessage="Location" />
                                                </th>
                                                <th scope="col">
                                                    <FormattedMessage id="price" defaultMessage="Price" />
                                                </th>
                                                <th scope="col">
                                                    <FormattedMessage id="location" defaultMessage="Location" />
                                                </th>
                                                <th scope="col">
                                                    <FormattedMessage id="price" defaultMessage="Price" />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {deliveryRatesByLocation.map((row, index) => (
                                                <tr key={index}>
                                                    <td>{row[0] ? row[0].location : ''}</td>
                                                    <td>{row[0] ? row[0].price : ''}</td>
                                                    <td>{row[1] ? row[1].location : ''}</td>
                                                    <td>{row[1] ? row[1].price : ''}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <Paragraph>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage id="shippingPolicy.subtitle5" defaultMessage="Delivery times by destinations:" />
                                    </strong>
                                </Paragraph>
                                <div className={styles.tableResponsive}>
                                    <table className="table table-bordered">
                                        <tbody>
                                            {deliveryTimeByDestination.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <strong>
                                                            {item.destination}
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {item.content}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <Paragraph>
                                    <strong>
                                        (*)
                                        {' '}
                                        <FormattedMessage id="shippingPolicy.subtitle3.table.text13" defaultMessage="Estimated deadlines will vary depending on the selected products" />
                                    </strong>
                                </Paragraph>
                                {/* <FormattedHTMLMessage id="shipping-policy__delivery-fees-for-stores-disclaimer" />
                                <Paragraph>
                                    <strong style={{ textDecoration: 'underline' }}>
                                        <FormattedMessage id="shippingPolicy.subtitle3.table.text14" defaultMessage="Shipping rates and delivery time for" />
                                    </strong>
                                    <br/>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage id="shippingPolicy.subtitle3.table.text15" defaultMessage="STORES AND RESTAURANTS IN HAVANA:" />
                                    </strong>
                                </Paragraph>
                                <div className={styles.tableResponsive}>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th scope="col">
                                                    <FormattedMessage id="store-table-header-text1" defaultMessage="Store" />
                                                </th>
                                                <th scope="col" style={{ width: '15%' }}>
                                                    <FormattedMessage id="store-table-header-text2" defaultMessage="Delivery Time" />
                                                </th>
                                                <th scope="col">
                                                    <FormattedMessage id="store-table-header-text3" defaultMessage="Delivery Price" />
                                                </th>
                                                <th scope="col">
                                                    <FormattedMessage id="store-table-header-text4" defaultMessage="Description" />
                                                </th>
                                                <th scope="col">
                                                    <FormattedMessage id="store-table-header-text5" defaultMessage="Notes" />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {stores.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        {item.name}
                                                    </td>
                                                    <td>
                                                        {item.deliveryTime}
                                                    </td>
                                                    <td>
                                                        {item.deliveryPrice}
                                                    </td>
                                                    <td>
                                                        <FormattedHTMLMessage
                                                            id={item.description.id}
                                                            defaultMessage={item.description.default}
                                                        />
                                                    </td>
                                                    <td>
                                                        {item.notes && (
                                                            <FormattedMessage
                                                                id={item.notes.id}
                                                                defaultMessage={item.notes.default}
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div> */}
                                <Paragraph>
                                    <FormattedHTMLMessage
                                        id="shippingPolicy.any_question"
                                        defaultMessage='Si aún tiene preguntas sobre los plazos y condiciones de entrega por favor contáctenos a través del <b>Centro de Ayuda</b> disponible en el sitio <b><a href=\"https://www.cubalicores.com\">www.cubalicores.com</a></b> o por el email <a href=\"mailto:info@cubalicores.com\">info@cubalicores.com</a>. Nuestros representantes de soporte recibirán su mensaje y le responderán lo antes posible.'
                                    />
                                </Paragraph>

                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}

export default injectIntl(ShippingPolicy);



/** WEBPACK FOOTER **
 ** ./src/components/pages/shipping-policy.jsx
 **/